module.exports = __webpack_public_path__ + "static/2front-ux-3-9c2f13713dbd3367de2ff0d2ebed14e9.png";